import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppStorage } from '../../shared/services/appStorage.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(private appStorage: AppStorage, private router: Router) {}

  ngOnInit() {
    if (
      this.appStorage.datosSesion.perfil !==
      this.appStorage.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      this.appStorage.goHome();
    }
  }
}
